// @flow
import React from "react";
import { useSelector } from "react-redux";

import {
  SelecaoCasasDecimais,
  SelecaoPeriodo,
  SelecaoAjusteDias,
  SelecaoBenchmark,
  SelecaoJanelaMovel,
  SelecaoPeriodicidade,
} from "../configuracoes";
import {
  comGeradorDePeriodo,
  getEdicaoMedida,
  getDataBaseSelecionadaAsString,
  isModoSeries,
  analiseValorDaMedida,
} from "../../../state";
import { VALOR_DEFAULT_BENCHMARK_QUANTITATIVA } from "../../../model";

export const processarPeriodoDiarioComBenchmark = comGeradorDePeriodo(
  (state, medidas) => {
    const edicaoMedida = getEdicaoMedida(state);
    const dataBase = getDataBaseSelecionadaAsString(state);
    const modoSeries = isModoSeries(state);

    if (modoSeries) {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        benchmark:
          edicaoMedida.benchmark || VALOR_DEFAULT_BENCHMARK_QUANTITATIVA,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    } else {
      return medidas.map(medidaSelecionada => ({
        ...medidaSelecionada,
        descricaoSelecao: "",
        periodicidade: edicaoMedida.periodicidade,
        ajusteDias: edicaoMedida.ajusteDias,
        benchmark: edicaoMedida.benchmark,
        dataBase: dataBase,
        janelaMovel: edicaoMedida.janelaMovel,
        ...analiseValorDaMedida(medidaSelecionada, state),
      }));
    }
  }
);

const PeriodoDiario = () => {
  const modoSeries = useSelector(isModoSeries);
  if (modoSeries) {
    return (
      <>
        <div className="ConfiguracaoMedida">
          <SelecaoBenchmark />
        </div>

        <div className="ConfiguracaoMedida__vertical-divider" />

        <div className="ConfiguracaoMedida">
          <SelecaoJanelaMovel />
        </div>
      </>
    );
  } else {
    return (
      <div className="ConfiguracaoMedida--no-flex">
        <div className="ConfiguracaoMedida--row">
          <SelecaoBenchmark />
          <SelecaoCasasDecimais />
        </div>

        <div className="ConfiguracaoMedida__horizontal-divider" />
        <div className="ConfiguracaoMedida--row">
          <SelecaoPeriodo exibirPeriodicidade={false} />
          <div className="ConfiguracaoMedida">
            <div className="ConfiguracaoMedida__box">
              <SelecaoPeriodicidade />
            </div>

            <div className="ConfiguracaoMedida__box">
              <SelecaoAjusteDias />
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default PeriodoDiario;
